export default class CreateBusinessHoursRequest  {
	name = '';  
    isMon = false;
	monOpenAt = '09:00';
	monCloseAt = '17:00';
	isTue = false;
	tueOpenAt = '09:00';
	tueCloseAt = '17:00';
	isWed = false;
	wedOpenAt = '09:00';
	wedCloseAt = '17:00';
	isThu = false;
	thuOpenAt = '09:00';
	thuCloseAt = '17:00';
	isFri = false;
	friOpenAt = '09:00';
	friCloseAt = '17:00';
	isSat = false;
	satOpenAt = '09:00';
	satCloseAt = '17:00';
	isSun = false;
	sunOpenAt = '09:00';
	sunCloseAt = '17:00';
}